import { RootState } from "./store";

export const interactionStateSelector = (state: RootState) => state.interaction.state;
export const interactionBoundarySpecSelector = (state: RootState) => state.interaction.boundarySpec;